import { PlayerWalletHistoryPage } from './../player-wallet-history/player-wallet-history';
import {
  ClubInfo,
  TeeTimeSlot,
  TeeTimeSlotDisplay,
  ClubCourseData,
  PlayerData,
  ClubData,
  TeeTimeClubVoucherSeries,
  TeeTimeClubVoucher,
  ClubCredit,
  PlayerClubWalletTopup,
  ClubMembership,
  ClubOutlet,
} from '../../../../data/mygolf.data';
import { Component, HostListener } from '@angular/core';
import { NavParams, ToastController, Platform } from '@ionic/angular';
import { CourseInfo, CourseHoleInfo } from '../../../../data/club-course';
import { ClubFlightService } from '../../../../providers/club-flight-service/club-flight-service';
import { TeeTimeBooking, PlayerClubWalletBalance } from '../../../../data/mygolf.data';

import * as moment from 'moment';
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { ModalController } from '@ionic/angular';
import { AddPlayerTypeDiscountPage } from '../player-voucher/add-player-type-discount/add-player-type-discount.page';
import { AlertController } from '@ionic/angular';
import { AddPlayerListPage } from '../add-player-list/add-player-list.page';
import { PlayerInfo } from '../../../../data/player-data';
import { JsonService } from '../../../../json-util';
import { ImageZoomPage } from '../image-zoom/image-zoom.page';
import { Country } from '../../../../data/country-location';
import { CountryListPage } from '../country-list/country-list.page';
import { PlayerService } from '../../../../providers/player-service/player-service';
// import { PlayerService } from '../../../../providers/player-service/player-service';
import { NavController } from '@ionic/angular';
import { PlayerRefundRedeemHistoryPage } from '../player-refund-redeem-history/player-refund-redeem-history.page';
import { mygolfUtils } from '../../../../custom/mygolf2u-utils';
// import { mygolfUtils } from '../../../custom/mygolf2u-utils';
import { ExpenditureTypeListPage } from '../expenditure-type-list/expenditure-type-list';
import { ConnectionService } from '../../../../providers/connection-service/connection-service';
import { OutletListPage } from '../outlet-list/outlet-list.page';
/**
 * Created by ashok on 19/12/16.
 */
@Component({
  templateUrl: 'club-player-wallet-topup.html',
  selector: 'club-player-wallet-topup-modal',
  styleUrls: ['club-player-wallet-topup.scss'],
})
export class ClubPlayerWalletTopupModal {
  courses: Array<CourseInfo>;
  clubId: number;
  forDate: string;
  isClub: boolean = false;
  courseId: number;
  teeSlot: Array<TeeTimeSlotDisplay>;
  startCourses: Array<ClubCourseData>;
  changeType: string;
  currentSlot: TeeTimeBooking;
  color: string;
  currentTime: string;
  mode: string;
  type: string;
  optionTypes: string = 'club';
  fromClub: boolean = false;
  selectedVoucher: boolean = false;
  selectedPlayer: boolean = false;
  hasPlayer: boolean = false;
  player: any; //PlayerInfo; //PlayerData
  clubInfo: ClubInfo;
  searchClubId: number;
  playerNoOfVoucher: number = 1;
  clubVoucherSeries: Array<TeeTimeClubVoucherSeries>;
  searchVoucher: string;
  selVoucherSeries: TeeTimeClubVoucherSeries;
  playerVoucher: Array<TeeTimeClubVoucher>;
  currencySymbol: string;
  playerCredits: Array<any>;
  totalClubCredits: number;
  preferredCountry: Country;
  countryList: Array<Country>;
  appFooterHide: boolean = true;
  clubBalanceType: string = 'credits';
  totalWalletBalance: number;
  totalTopupAmount: number;

  selectedClub: any;
  isClubSpecific: boolean = false;
  clubSpecificThemes: Array<any>;

  playerWalletBalance: PlayerClubWalletBalance;
  toggleTopupDetails: boolean = false;

  topupAmount: number = 0;
  topupDate: string;

  trxnAmount: number = 0;
  trxnDate: string;
  expenditureType: string;
  trxnRemarks: string = '';
  expiryDate: string;
  membershipType: string;
  membersOnly: boolean = false;
  maxDate: string;

  editMode: boolean = false;
  topupDetails: PlayerClubWalletTopup;
  appAttribute: any;
  clubMembership: ClubMembership;
  expenditureTypes: Array<string>;
  trxnRef: string = '';

  clubOutletList: Array<ClubOutlet>;
  selectedClubOutlet: ClubOutlet;
  isClubOutlet: boolean = false;
  constructor(
    private flightService: ClubFlightService,
    private navParams: NavParams,
    private toastCtl: ToastController,
    private platform: Platform,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private playerService: PlayerService,
    private navCtrl: NavController,
    private mg2uUtil: mygolfUtils,
    private connService: ConnectionService
  ) {
    this.courses = navParams.get('courses');
    this.clubId = navParams.get('clubId');
    this.forDate = navParams.get('forDate');
    this.courseId = navParams.get('courseId');
    this.changeType = navParams.get('changeType');
    this.currentSlot = navParams.get('currentSlot');
    if (this.changeType && this.changeType === 'slot') this.isClub = false;
    else if (this.changeType && this.changeType === 'course') this.isClub = true;
    this.mode = navParams.get('mode');
    // this.type = navParams.get("type");
    this.fromClub = navParams.get('fromClub');
    this.clubInfo = navParams.get('clubInfo');
    if (this.fromClub) this.type = 'club';
    this.currencySymbol = navParams.get('currencySymbol');
    this.player = navParams.get('player');

    this.isClubSpecific = this.navParams.get('isClubSpecific');
    this.selectedClub = this.navParams.get('selectedClub');
    this.clubSpecificThemes = this.navParams.get('clubSpecificThemes');

    this.topupDate = moment().format('YYYY-MM-DD');
    this.expiryDate = moment().add('1', 'years').format('YYYY-MM-DD');
    this.maxDate = moment().add('5', 'years').format('YYYY-MM-DD');

    this.trxnDate = moment().format('YYYY-MM-DD');

    this.editMode = navParams.get('editMode');
    this.topupDetails = navParams.get('topupDetails');

    if (this.editMode) {
      this.player = this.topupDetails.player;
      this.topupDate = moment(this.topupDetails.topUpDate).format('YYYY-MM-DD');
      this.expiryDate = moment(this.topupDetails.validUntil).format('YYYY-MM-DD');
      this.topupAmount = this.topupDetails.topUpAmount;
    }

    if (this.mode === 'transaction') {
      this.getExpenditureTypes();
    }

    this.appAttribute = navParams.get('appAttribute');

    this.isClubOutlet = navParams.get('isClubOutlet');
    if (this.isClubOutlet) {
      this.selectedClubOutlet = navParams.get('selectedClubOutlet');
      this.clubOutletList = navParams.get('clubOutletList');
    } else if (this.mode === 'transaction') {
      this.getClubOutletList();
    }
  }

  innerWidth: any;
  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  ionViewDidLoad() {
    // this.getPlayerCredits();
    // this.getCountryList();
    if (this.mode === 'wallet') {
      this.clubBalanceType = this.mode;
      this.refreshWallet();
    } else if (this.mode === 'credits') {
      this.clubBalanceType = this.mode;
      // this.getPlayerCredits();
    } else if (this.mode === 'transaction') {
      this.clubBalanceType = this.mode;
    } else if (this.mode === 'topup') {
      this.clubBalanceType = this.mode;
    }
    // this.getClubVoucherSeries();
    // this.getTeeTimeBookingList();
  }
  close() {
    this.modalCtrl.dismiss();
  }
  selectHole(hole: CourseHoleInfo, whichNine: number) {
    this.modalCtrl.dismiss({
      hole: hole,
      whichNine: whichNine,
    });
  }

  getTeeTimeBookingList() {
    let _clubCourseId;
    this.startCourses = [];
    // let _courseId;
    // _courseId = this.courseId;
    _clubCourseId = this.isClub ? this.clubId : this.courseId;
    this.flightService
      .getTeeTimeSlot(this.forDate, this.isClub, _clubCourseId)
      .subscribe((data: Array<TeeTimeSlotDisplay>) => {
        this.teeSlot = data;
        if (this.changeType === 'course') {
          this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
            return (
              tee.slot.teeOffTime === this.currentSlot.slotAssigned.teeOffTime &&
              tee.slot.startCourse.id !== this.currentSlot.slotAssigned.startCourse.id
            );
          });
        } else {
          this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
            return tee.slot.teeOffTime !== this.currentSlot.slotAssigned.teeOffTime;
            // && (tee.slot.teeOffDate === moment().toDate() && (moment(tee.slot.teeOffTime,'HH:mm:ss').format('HH:mm') >= moment().format('HH:mm')))
          });
        }

        this.teeSlot.forEach((t: TeeTimeSlotDisplay) => {
          this.startCourses.push(t.slot.startCourse);
        });

        this.startCourses = this.getUnique(this.startCourses, 'id');
        this.startCourses.sort((a, b) => {
          if (a.displayOrder < b.displayOrder) return -1;
          if (a.displayOrder > b.displayOrder) return 1;
          else 0;
        });
      });
  }

  getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map(e => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter(e => arr[e])
      .map(e => arr[e]);

    return unique;
  }

  changeSlot(slot: TeeTimeSlotDisplay, type?: string) {
    if (!slot.available && type === 'slot') return false;
    // && type === 'course'
    this.flightService
      .getBookingFlightList(this.clubId, moment(slot.slot.teeOffDate).format('YYYY-MM-DD'), true)
      .subscribe(data => {
        let _flightList: Array<TeeTimeBooking>;
        let _hasFlight: Array<TeeTimeBooking>;
        if (data) {
          _flightList = data.flightList;
          _hasFlight = _flightList.filter((t: TeeTimeBooking) => {
            return (
              t.slotAssigned.slotNo === slot.slot.slotNo &&
              t.slotAssigned.slotDayId === slot.slot.slotDayId
            );
          });
        }
        if (_hasFlight && _hasFlight.length > 0) {
          if (_hasFlight[0].flight && _hasFlight[0].flight.status === 'PlayFinished') {
            MessageDisplayUtil.showMessageToast(
              'There is Finished Flight in this slot. Please choose different slot.',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          } else {
            this.modalCtrl.dismiss({
              newSlot: slot,
              currentSlot: this.currentSlot,
            });
          }
        } else {
          this.modalCtrl.dismiss({
            newSlot: slot,
            currentSlot: this.currentSlot,
          });
        }
      });
    // if(1) return false;
  }
  // changeSlot(slot: TeeTimeSlotDisplay) {
  //
  //     if(!slot.available) return false;
  //     this.modalCtrl.dismiss({
  //         newSlot: slot,
  //         currentSlot: this.currentSlot
  //     });
  // }

  getSlotDetails(slot: TeeTimeSlotDisplay, attribute: string) {
    switch (attribute) {
      case 'time':
        let _time = moment(slot.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
        return _time;
    }
  }

  getCurrentSlotDetails(attribute) {
    switch (attribute) {
      case 'time':
        let _time = moment(this.currentSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format('hh:mm A');
        return _time;
      case 'courseName':
        let _courseName = this.currentSlot.slotAssigned.startCourse.name;
        return _courseName;
    }
  }

  getSlotClass(slot: TeeTimeSlotDisplay) {
    // if(slot.available) this.color = 'danger';
    // else this.color = 'primary'

    if (this.changeType === 'course') return 'slot-available';
    else {
      // return this.color
      if (slot.available) return 'slot-available';
      else return 'slot-not-available';
    }
  }

  setOptionType(type: number) {
    if (type === 1) {
      this.optionTypes = 'mygolf2u';
      this.selectedVoucher = false;
      this.selectedPlayer = false;
      // this.friendScreenName = 'Search';
      // if (this.platform.is("ios") && this.platform.is("cordova")) {
      //     this.keyboard.close();
      // }
    }
    if (type === 2) {
      this.optionTypes = 'club';
      this.selectedVoucher = false;
      this.selectedPlayer = false;
      // this.friendScreenName = 'My Bookings';
      // this._refreshRequest(null, null);
      // this.refreshActiveBooking();
      // if (this.platform.is("ios") && this.platform.is("cordova")) {
      //     this.keyboard.close();
      // }
    }
  }

  async onEditClick(type?: string) {
    let headerTitle;
    switch (type) {
      case 'playerType':
        headerTitle = 'Edit Player Type';
        break;
      case 'playerDiscount':
        headerTitle = 'Edit Discount Card';
        break;
      case 'playerVoucher':
        headerTitle = 'Manage Voucher(s)';
        break;
    }
    let typeModal = await this.modalCtrl.create({
      component: AddPlayerTypeDiscountPage,
      componentProps: {
        headerTitle: headerTitle,
        type: type, //playerType, playerDiscount, playerVoucher
        mode: 'edit', //new edit
      },
    });

    let _deleteMultiDone: boolean = false;
    typeModal.onDidDismiss().then((data: any) => {
      if (data) {
      }
    });
    typeModal.present();
  }

  async onAddClick(type?: string) {
    let headerTitle;
    switch (type) {
      case 'playerType':
        headerTitle = 'Add Player Type';
        break;
      case 'playerDiscount':
        headerTitle = 'Add Discount Card';
        break;
      case 'playerVoucher':
        headerTitle = 'Manage Voucher(s)';
        break;
    }

    let typeModal = await this.modalCtrl.create({
      component: AddPlayerTypeDiscountPage,
      componentProps: {
        headerTitle: headerTitle,
        type: type, //playerType, playerDiscount, playerVoucher
        mode: 'new', //new edit
      },
    });

    let _deleteMultiDone: boolean = false;
    typeModal.onDidDismiss().then((data: any) => {
      if (data) {
      }
    });
    typeModal.present();
  }

  async onRemoveClick(type?: string) {
    let headerTitle;
    let message;
    switch (type) {
      case 'playerType':
        headerTitle = 'Removing Player Type';
        message = 'Do you want to remove selected Player Type?';
        break;
      case 'playerDiscount':
        headerTitle = 'Removing Discount Card';
        message = 'You will lose privilege/discount deals by the club. Do you want to proceed?';
        break;
      case 'playerVoucher':
        headerTitle = 'Removing Voucher';
        message = 'Do you want to remove selected Voucher?';
        break;
    }
    let prompt = await this.alertCtrl.create({
      header: headerTitle,
      message: message,
      // inputs: [{
      //     name: 'title',
      //     placeholder: 'Group Name'
      // }, ],
      buttons: [
        {
          text: 'No',
          // handler: data => {
          //     prompt.dismiss().then(() => {
          //         this.keyboard.close();
          //     });
          //     return false;
          // }
        },
        {
          text: 'Yes',
          // handler: data => {
          //     _required = '';
          //     if (data.title)
          //         prompt.dismiss().then(() => {
          //             this._createPlayerGroup(data.title);
          //         })
          //     else {
          //         // _required = 'Please enter Group Name';
          //         // _message = '<br>Please enter the Group Name';
          //         let msg = MessageDisplayUtil.getErrorMessage('', "Please enter Group name");
          //         MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl,
          //             5000, "bottom");
          //     }
          //     return false;
          // }
        },
      ],
    });
    prompt.present();
  }

  async onSelectPlayer() {
    if (this.editMode) return;
    if (!this.fromClub) return;
    let _membersOnly: boolean = false;
    let _playerWallet: boolean = false;
    if (this.mode === 'topup') {
      _membersOnly = false;
      _playerWallet = false;
    } else if (this.mode === 'transaction') _playerWallet = true;
    let _playerModal = await this.modalCtrl.create({
      component: AddPlayerListPage,
      componentProps: {
        fromClub: true,
        openedModal: true,
        clubId: this.clubId,
        // membershipType: 'P',
        membersOnly: _membersOnly,
        initTab: 'members',
        playerWallet: _playerWallet,
        noNewPlayer: true,
        currencySymbol: this.currencySymbol,
      },
    });

    _playerModal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.player = data.data.item;
        if (this.player) this.hasPlayer = true;
        else this.hasPlayer = false;
        if (data.data.membershipDetails) this.clubMembership = data.data.membershipDetails;
        this.selectedPlayer = true;
        this.selectedVoucher = false;
        if (this.clubMembership && this.clubMembership.membershipType != 'P') {
          this.maxDate = moment('2999-12-31', 'YYYY-MM-DD').format('YYYY-MM-DD');
          this.expiryDate = moment('2999-12-31', 'YYYY-MM-DD').format('YYYY-MM-DD');
        } else {
          this.maxDate = moment(this.topupDate).add('5', 'years').format('YYYY-MM-DD');
          this.expiryDate = moment(this.topupDate).add('1', 'years').format('YYYY-MM-DD');
        }
      } else {
        this.selectedPlayer = false;
        this.hasPlayer = false;
      }
    });
    _playerModal.present();
  }

  onSearchVoucherClick(type?: string) {
    this.clubVoucherSeries = [];

    let _clubId = this.clubId ? this.clubId : this.clubInfo.clubId;
    // let _playerId;
    // if(this.clubId || this.clubInfo && this.clubInfo.clubId) _clubId = this.clubInfo && this.clubInfo.clubId?this.clubInfo.clubId:this.clubId;
    // if(type.length > 0 && type === 'club') this.clubId = this.searchClubId;

    this.flightService
      .getClubVoucherSeries(1, _clubId, this.searchVoucher)
      .subscribe((data: any) => {
        let _voucher: Array<TeeTimeClubVoucherSeries>;
        if (data && data.items) {
          _voucher = data.items;

          if (_voucher && _voucher.length > 0) {
            _voucher.forEach((vs: TeeTimeClubVoucherSeries) => {
              JsonService.deriveFulImageURL(vs, 'voucherImage');
            });
            this.clubVoucherSeries = _voucher;
          }
        }
      });
  }

  onRefreshClick() {
    this.getClubVoucherSeries();
  }

  getClubVoucherSeries() {
    this.clubVoucherSeries = [];

    // listClubVoucherSeries
    let _clubId = this.clubId ? this.clubId : this.clubInfo.clubId;
    this.flightService.getClubVoucherSeries(1, _clubId).subscribe((data: any) => {
      let _voucher: Array<TeeTimeClubVoucherSeries>;
      if (data && data.items) {
        _voucher = data.items;

        if (_voucher && _voucher.length > 0) {
          _voucher.forEach((vs: TeeTimeClubVoucherSeries) => {
            JsonService.deriveFulImageURL(vs, 'voucherImage');
          });
          this.clubVoucherSeries = _voucher;
        }
      }
    });

    // this.flightService.getClubVoucherSeries(2,_clubId)
    // .subscribe((voucherSeries: Array<TeeTimeClubVoucherSeries>)=>{
    //
    //     if(voucherSeries && voucherSeries.length> 0) {
    //         this.clubVoucherSeries = voucherSeries;
    //     }
    // })
  }

  getVoucherAmount(voucher: TeeTimeClubVoucherSeries, type: string) {
    let _totalVouchers;
    _totalVouchers = voucher.totalVouchers;
    switch (type) {
      case 'assigned':
        return voucher.vouchersIssued;
      case 'remaining':
        return _totalVouchers - voucher.vouchersIssued;
    }
  }

  getDateText(date: string) {
    if (date.length === 0) return false;
    let _date = date;
    return moment(_date, 'YYYY-MM-DD').format('DD MMM YYYY');
  }

  getVoucherApplicableText(voucher: TeeTimeClubVoucherSeries, type: string) {
    if (!voucher) return false;
    let _allowText;
    let _applicableStart = 'Applicable on';
    let _allowWeekdays;
    let _allowWeekends;
    let _allowHolidays;
    let _applicableEnd = '';
    if (type === 'allowDays') {
      // _allowWeekdays = voucher.allowOnWeekdays?'Weekdays':'';
      // _allowWeekends = voucher.allowOnWeekends?'Weekends':'';
      // _allowHolidays = voucher.allowOnPublicHolidays?'Public Holidays':'';
      _allowWeekdays =
        voucher && (voucher.allowOnWeekends || voucher.allowOnPublicHolidays)
          ? 'Weekdays' + ', '
          : voucher && voucher.allowOnWeekdays
            ? 'Weekdays'
            : '';
      _allowWeekends =
        voucher && voucher.allowOnPublicHolidays
          ? 'Weekends' + ', '
          : voucher && voucher.allowOnWeekends
            ? 'Weekends'
            : '';
      _allowHolidays =
        voucher &&
        (voucher.allowOnWeekdays || (voucher.allowOnWeekends && voucher.allowOnPublicHolidays))
          ? ' and ' + 'Public Holidays'
          : voucher && voucher.allowOnPublicHolidays
            ? 'Public Holidays'
            : '';

      _allowText = _applicableStart + ' ' + _allowWeekdays + _allowWeekends + _allowHolidays;

      //
      //
      //
      //
      //
      //

      // if(voucher.allowOnWeekdays && voucher.allowOnWeekends && voucher.allowOnPublicHolidays)
      // _allowText = 'Applicable on Weekdays, Weekends and Public Holidays';
      // else if(!voucher.allowOnWeekdays && voucher.allowOnWeekends && voucher.allowOnPublicHolidays)
      // _allowText = 'Applicable on Weekends and Public Holidays';
      // else if(!voucher.allowOnWeekdays && !voucher.allowOnWeekends && voucher.allowOnPublicHolidays)
      // _allowText = 'Applicable only on Public Holidays';
      // else if()
      // else _allowText = 'Applicable to these days';
    } else if (type === 'bookingAmount') {
      _allowText = 'Applies to Booking Amount';
    } else if (type === 'flight') {
      _allowText = 'Applicable for this flight';
    }

    return _allowText;
  }

  async onImageClick(imageUrl: string) {
    let image = await this.modalCtrl.create({
      component: ImageZoomPage,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        image: imageUrl,
      },
    });

    image.present();
  }

  onSeriesAssignClick(voucher: TeeTimeClubVoucherSeries) {
    // this.selVoucherSeries = null;
    this.selVoucherSeries = voucher;
    this.selectedVoucher = true;
  }

  onPlayerAssignClick(voucher: TeeTimeClubVoucherSeries, player: PlayerData | PlayerInfo) {
    if (!this.player) {
      MessageDisplayUtil.showErrorToast(
        'Please select a player before assigning',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return false;
    }
    if (this.playerNoOfVoucher === 0 || !this.playerNoOfVoucher) {
      MessageDisplayUtil.showErrorToast(
        'Please enter at least 1 number of voucher',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return false;
    }
    let _currentVoucherSeries = this.selVoucherSeries;
    let _clubId = this.clubId ? this.clubId : this.clubInfo.clubId;
    let _playerId = player ? player.playerId : this.player.playerId;
    let _currentDate = moment().format('YYYY-MM-DD');
    this.flightService
      .assignClubPlayerVoucher(_clubId, _playerId, voucher.id, this.playerNoOfVoucher, _currentDate)
      .subscribe((data: any) => {
        if (data && data.status === 200) {
          this.flightService.getClubVoucherSeries(1, _clubId).subscribe((data: any) => {
            let _voucher: Array<TeeTimeClubVoucherSeries>;
            if (data && data.items) {
              _voucher = data.items;

              if (_voucher && _voucher.length > 0) {
                _voucher.forEach((vs: TeeTimeClubVoucherSeries) => {
                  JsonService.deriveFulImageURL(vs, 'voucherImage');
                });
                this.clubVoucherSeries = _voucher;
                _voucher
                  .filter((vs: TeeTimeClubVoucherSeries) => {
                    return vs.id === _currentVoucherSeries.id;
                  })
                  .map((vs: TeeTimeClubVoucherSeries) => {
                    this.selVoucherSeries = vs;
                  });

                MessageDisplayUtil.showErrorToast(
                  'Successfully assigned ' + this.playerNoOfVoucher + ' vouchers',
                  this.platform,
                  this.toastCtl,
                  5000,
                  'bottom'
                );
              }
            }
          });
        }
      });
  }

  getPlayerVoucher() {
    let _clubId = this.clubId ? this.clubId : this.clubInfo.clubId;
    let _playerId = this.player.playerId;

    this.flightService
      .getListClubPlayerVouchers(_clubId, _playerId)
      .subscribe((data: Array<TeeTimeClubVoucher>) => {
        if (data) {
          this.playerVoucher = data.filter((v: TeeTimeClubVoucher) => {
            // return v.
            // v.voucherNumber.toLowerCase().includes(this.searchVoucher.toLowerCase()) ||
            // v.name.toLowerCase().includes(this.searchVoucher.toLowerCase())
          });
        }
      });
  }

  getPlayerDetails(player: PlayerInfo, attribute: string) {
    if (!player) return false;
    switch (attribute) {
      case 'image':
        return player && player.thumbnail ? player.thumbnail : player.photoUrl;
    }
  }

  getPlayerCredits() {
    let _playerId = this.player.playerId;
    this.flightService.getPlayerCredits(_playerId).subscribe((data: any) => {
      if (data) {
        data.forEach((cc: ClubCredit) => {
          JsonService.deriveFulImageURL(cc.club, 'clubImage');
          JsonService.deriveFulImageURL(cc.club, 'clubLogo');
        });
        this.playerCredits = data.filter((cc: ClubCredit) => {
          if (this.isClubSpecific && this.selectedClub) {
            return cc.club.id === this.selectedClub.clubId;
          } else return true;
        });
        if (this.playerCredits && this.playerCredits.length > 0) {
          this.totalClubCredits = this.playerCredits
            .map((a: ClubCredit) => {
              return a.balance;
            })
            .reduce((a, b) => {
              return a + b;
            });

          this.totalWalletBalance = this.playerCredits
            .map((a: ClubCredit) => {
              return a.walletBalance;
            })
            .reduce((a, b) => {
              return a + b;
            });
        }
      }
    });
  }

  refreshCredits() {
    this.getPlayerCredits();
  }

  getTotalClubCredits() {
    let _totalTxt = '';
    let _currency;
    let _totalCredits = 0; // this.playerCredits.
    if (this.playerCredits && this.playerCredits.length === 0) return '-';
    if (!this.playerCredits) return '-';
    if (!this.preferredCountry) return '-';
    let _filteredCredit = this.playerCredits.filter((pc: ClubCredit) => {
      return pc.club.address.countryData.id === this.preferredCountry.id;
    });
    if (_filteredCredit && _filteredCredit.length === 0) return '-';
    _totalCredits = _filteredCredit
      .map((pc: ClubCredit) => {
        _currency = pc.currency.symbol;
        return pc.balance;
      })
      .reduce((a, b) => {
        return a + b;
      });
    // _totalCredits = 2445.160000000000000003;
    _totalTxt = _currency + ' ' + _totalCredits.toFixed(2);
    return this.mg2uUtil.numberWithCommas(_totalTxt);
  }

  getTotalWalletBalance() {
    let _totalTxt = '';
    let _currency;
    let _totalWalletBalance = 0; // this.playerCredits.
    if (this.playerCredits && this.playerCredits.length === 0) return '-';
    if (!this.playerCredits) return '-';
    if (!this.preferredCountry) return '-';
    let _filteredCredit = this.playerCredits.filter((pc: ClubCredit) => {
      return pc.club.address.countryData.id === this.preferredCountry.id;
    });
    if (_filteredCredit && _filteredCredit.length === 0) return '-';
    _totalWalletBalance = _filteredCredit
      .map((pc: ClubCredit) => {
        _currency = pc.currency.symbol;
        return pc.walletBalance;
      })
      .reduce((a, b) => {
        return a + b;
      });
    // _totalCredits = 2445.160000000000000003;
    _totalTxt = _currency + ' ' + _totalWalletBalance.toFixed(2);
    return this.mg2uUtil.numberWithCommas(_totalTxt);
  }

  async onChangePreferredOrigin() {
    let modal = await this.modalCtrl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        excludeAll: true,
      },
    });
    modal.onDidDismiss().then((country?: any) => {
      if (country === null || country === -999) {
        // this.preferredCountry = ;
        this.countryList.filter(c => {
          if (c.id === this.player.countryId) this.preferredCountry = c;
          else if (c.id === this.player.addressInfo.countryId) this.preferredCountry = c;
        });
        // .map((c)=>{
        //     return c
        // })
        // || country === isUndefined
        // this.preferredCountry.
        //     // this.countryId = '';
        //     // this.countrySel.id = '';
        //     // this.countrySel.name = 'ALL'
        //     // this.countrySel.flagUrl = 'img/flag/default_worldwide.png';
        //     //
        //     // this.countrySelected(this.countryId)
        //     //
      } else {
        this.preferredCountry = country;
      }
      // else {
      //     let _country: Country = country;
      //     this.countryId = _country.id;
      //
      //     this.countrySelected(_country.id)

      //     // adjustViewZIndex(this.nav, this.renderer);
      // }

      setTimeout(() => {
        // this.getActiveComps();
      }, 500);

      //
      //
      //
      //
      //
    });
    modal.present();
  }

  getCountryList() {
    let _playerCountry = this.player.countryId;
    if (this.player) {
      if (this.player.addressInfo) _playerCountry = this.player.addressInfo.countryId;
      else if (this.player.address) _playerCountry = this.player.address.countryData.id;
      else if (this.player.userProfile && this.player.userProfile.nationality)
        _playerCountry = this.player.userProfile.nationality.id;
    }
    this.playerService.getCountryList().subscribe(
      (data: Array<Country>) => {
        //

        this.countryList = data;
        // this.preferredCountry =
        this.countryList
          .filter(pc => {
            if (pc.id === _playerCountry) this.preferredCountry = pc;
          })
          .map(pc => {
            return pc;
          });
        // this.countryList.push({
        //     id: 'ALL',
        //     name: 'ALL',
        //     flagUrl: 'img/flag/default-worldwide.png'
        // })
        //
      },
      error => {},
      () => {
        // this.countryList.filter((c)=>{
        //     return c.id === 'MYS'
        // })
      }
    );

    setTimeout(() => {
      // cb();
    }, 250);
  }

  filteredPlayerCredits() {
    let _playerCredits = [];
    let _preferredCountry: Country;

    if (!this.playerCredits) return _playerCredits;
    else if (this.playerCredits && this.playerCredits.length === 0) return _playerCredits;
    else if (this.playerCredits && this.playerCredits.length > 0) {
      if (!this.preferredCountry)
        _preferredCountry = {
          id: this.player.countryId ? this.player.countryId : this.player.addressInfo.countryId,
        };
      else _preferredCountry = this.preferredCountry;
      _playerCredits = this.playerCredits.filter((pc: ClubCredit) => {
        return pc.club.address.countryData.id === _preferredCountry.id;
      });

      return _playerCredits;
    } else return _playerCredits;
  }
  async goRefundRedeemHistory(clubCredit: ClubCredit) {
    let _modal = await this.modalCtrl.create({
      component: PlayerRefundRedeemHistoryPage,
      componentProps: {
        clubId: clubCredit.club.id,
        player: this.player,
        clubCredit: clubCredit,
        preferredCountry: this.preferredCountry,
      },
    });
    _modal.present();
  }

  refreshWallet() {
    if (!this.isClubSpecific) return;
    let _clubId;
    if (this.selectedClub) _clubId = this.selectedClub.clubId;
    let _playerId = this.player.playerId;
    this.flightService
      .getPlayerWalletBalance(_clubId, _playerId)
      .subscribe((playerWallet: PlayerClubWalletBalance) => {
        if (playerWallet) {
          this.playerWalletBalance = playerWallet;
          this.totalTopupAmount = this.playerWalletBalance.topups
            .map((a: PlayerClubWalletTopup) => {
              return a.topUpAmount;
            })
            .reduce((a, b) => {
              return a + b;
            }, 0);
        }
      });
  }

  async goPlayerWalletHistory(clubCredit: ClubCredit) {
    let _modal = await this.modalCtrl.create({
      component: PlayerWalletHistoryPage,
      componentProps: {
        clubId: clubCredit.club.id,
        player: this.player,
        clubCredit: clubCredit,
        preferredCountry: this.preferredCountry,
        playerWalletBalance: this.playerWalletBalance,
      },
    });
    _modal.present();
  }

  onAddTopupClick() {
    let _message = '';
    let _hasError: boolean = false;
    if (!this.player) {
      _message = 'Please select a player to add topup';
      _hasError = true;
    } else if (!this.topupDate) {
      _message = 'Please specify topup date';
      _hasError = true;
    } else if (!this.expiryDate) {
      _message = 'Please specify expiry date';
      _hasError = true;
    } else if (this.expiryDate < this.topupDate) {
      _message = 'Please specify valid dates';
      _hasError = true;
    } else if (this.topupAmount === 0) {
      _message = 'Please specify a topup amount';
      _hasError = true;
    }
    if (_hasError) {
      MessageDisplayUtil.showErrorToast(_message, this.platform, this.toastCtl, 5000, 'bottom');
      return;
    } else {
      this.goAddClubPlayerTopup();
    }
  }

  async onAddTrxnClick() {
    let _message = '';
    let _hasError: boolean = false;

    if (!this.player) {
      _message = 'Please select a player to add transaction';
      _hasError = true;
    } else if (this.player && !this.player.id && !this.player.playerId) {
      _message = 'Please re-select a player to add transaction';
      _hasError = true;
    } else if (!this.trxnDate) {
      _message = 'Please specify transaction date';
      _hasError = true;
    } else if (!this.fromClub && !this.selectedClubOutlet) {
      _message = 'Please specify an outlet';
      _hasError = true;
    } else if (this.fromClub) {
      if (!this.expenditureType && !this.selectedClubOutlet) {
        _message = 'Please specify an expenditure type or club outlet';
        _hasError = true;
      }
      // if(!this.expenditureType) {
      //     _message = 'Please specify expenditure type';
      //     _hasError = true;
      // } else if(!this.selectedClubOutlet) {
      //     _message = 'Please specify an outlet';
      //     _hasError = true;
      // }
    }
    // else if(!this.expiryDate) {
    //     _message = 'Please specify expiry date';
    //     _hasError = true;
    // } else if(this.expiryDate < this.topupDate) {
    //     _message = 'Please specify valid dates';
    //     _hasError = true;
    // }
    else if (this.trxnAmount === 0) {
      _message = 'Please specify a transaction amount';
      _hasError = true;
    }
    if (_hasError) {
      MessageDisplayUtil.showErrorToast(_message, this.platform, this.toastCtl, 5000, 'bottom');
      return;
    } else {
      if (!this.fromClub) {
        let prompt = await this.alertCtrl.create({
          header: 'Pay Confirmation',
          message:
            'You are paying for ' +
            this.selectedClubOutlet.name +
            ' for amount ' +
            '<b>' +
            this.currencySymbol +
            ' ' +
            this.mg2uUtil.numberWithCommas(this.trxnAmount) +
            '</b>' +
            '. Do you want to proceed?',
          buttons: [
            {
              text: 'No',
            },
            {
              text: 'Yes',
              handler: data => {
                this.goAddPlayerTransaction();
              },
            },
          ],
        });
        prompt.present();
      } else this.goAddPlayerTransaction();
    }
  }

  goAddClubPlayerTopup() {
    let _clubId = this.clubId;
    let _playerId = this.player.playerId;
    let _params = {
      topUpDate: this.topupDate,
      expiryDate: this.expiryDate,
      amount: this.topupAmount,
    };

    this.flightService.addClubPlayerTopup(_clubId, _playerId, _params).subscribe(data => {
      if (data) {
        this.modalCtrl.dismiss(true);
        MessageDisplayUtil.showMessageToast(
          'Successfully topup for selected player',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return;
      }
    });
  }

  goAddPlayerTransaction() {
    let _clubId = this.clubId;
    let _playerId = this.player.playerId ? this.player.playerId : this.player.id;
    let _trxnRef;
    let _trxnRefId = '';
    _trxnRefId = moment().format('YYYYMMDDHHmmss');

    //? this is to remove any (Reverse) word in the add transaction description
    let reReverse = /\(Reversed\)/gi;
    this.trxnRemarks = this.trxnRemarks.replace(reReverse, '');
    if (!this.fromClub) {
      if (!this.selectedClubOutlet)
        _trxnRef = '[Player eWallet trxn] ' + _trxnRefId + ' ' + this.trxnRemarks;
      else
        _trxnRef = '[' + this.selectedClubOutlet.name + '] ' + _trxnRefId + ' ' + this.trxnRemarks;
    } else _trxnRef = this.trxnRef;
    let _params = {
      amount: this.trxnAmount,
      transactionDate: this.trxnDate,
      expenditureType: this.expenditureType,
      outletId: this.selectedClubOutlet.id,
      reference: _trxnRef,
      description: this.trxnRemarks,
    };

    this.flightService.deductWalletBalance(_clubId, _playerId, _params).subscribe(
      data => {
        if (data) {
          let _message = '';

          if (!this.fromClub) _message = 'Successfully made payment from e-Wallet';
          else _message = 'Successfully added expenditure for selected player';
          this.modalCtrl.dismiss(true);
          MessageDisplayUtil.showMessageToast(
            _message,
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          return;
        }
      },
      error => {
        let _error = error.json();
        let _message = 'Please contact system administrator';
        if (_error.errorCode === 'Wallet.NotEnoughBalance') {
          if (this.fromClub) _message = 'Selected player does not have enough e-Wallet balance.';
          else _message = 'You do not have enough e-Wallet balance.';
        }
        MessageDisplayUtil.showErrorToast(_message, this.platform, this.toastCtl, 5000, 'bottom');
      }
    );
  }

  changeDate(attribute: string) {
    if (attribute === 'start' && this.clubMembership && this.clubMembership.membershipType != 'P') {
      this.maxDate = moment('2999-12-31', 'YYYY-MM-DD').format('YYYY-MM-DD');
      this.expiryDate = moment('2999-12-31', 'YYYY-MM-DD').format('YYYY-MM-DD');
    } else if (attribute === 'start') {
      this.maxDate = moment(this.topupDate).add('5', 'years').format('YYYY-MM-DD');
      this.expiryDate = moment(this.topupDate).add('1', 'years').format('YYYY-MM-DD');
    }
  }

  setMaxDate(date: string) {
    return moment(date).add('1', 'years').format('YYYY-MM-DD');
  }

  onUpdateTopupClick() {
    let _message = '';
    let _hasError: boolean = false;
    if (!this.player) {
      _message = 'Please select a player to add topup';
      _hasError = true;
    } else if (!this.topupDate) {
      _message = 'Please specify topup date';
      _hasError = true;
    } else if (!this.expiryDate) {
      _message = 'Please specify expiry date';
      _hasError = true;
    } else if (this.expiryDate <= this.topupDate) {
      _message = 'Please specify valid dates';
      _hasError = true;
    } else if (this.topupAmount === 0) {
      _message = 'Please specify a topup amount';
      _hasError = true;
    }
    if (_hasError) {
      MessageDisplayUtil.showErrorToast(_message, this.platform, this.toastCtl, 5000, 'bottom');
      return;
    } else {
      this.goUpdateClubPlayerTopup();
    }
  }

  goUpdateClubPlayerTopup() {
    let _clubId = this.clubId;
    let _playerId = this.player && this.player.id ? this.player.id : this.player.playerId;
    let _topupId = this.topupDetails.id;
    let _params = {
      topUpDate: this.topupDate,
      // expiryDate: this.expiryDate,
      // amount: this.topupAmount,
      topUpAmount: this.topupAmount,
      validUntil: this.expiryDate,
    };

    this.flightService
      .updateClubPlayerTopup(_clubId, _playerId, _topupId, _params)
      .subscribe(data => {
        if (data) {
          this.modalCtrl.dismiss(true);
          MessageDisplayUtil.showMessageToast(
            'Successfully updated topup details for selected player',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          return;
        }
      });
  }

  checkDisableTopupAmount() {
    if (!this.appAttribute) return true;
    if (this.appAttribute && this.appAttribute.disableTopupAmount === true) {
      return true;
    } else if (this.appAttribute && this.appAttribute.disableTopupAmount === false) {
      return false;
    } else return true;
  }

  getClubOutletList() {
    let _clubId = this.clubId;
    let _search;

    this.flightService.getClubOutletList(_clubId, _search).subscribe(data => {
      if (data) this.clubOutletList = data;
    });
  }

  getExpenditureTypes() {
    let _clubId = this.clubId;
    let _search;

    this.flightService.getExpenditureTypes(_clubId, _search).subscribe(data => {
      if (data) this.expenditureTypes = data;
    });
  }

  async changeExpenditureType() {
    let _expTypeModal = await this.modalCtrl.create({
      component: ExpenditureTypeListPage,
      componentProps: {
        expenditureTypes: this.expenditureTypes,
        fromClub: this.fromClub,
      },
    });
    _expTypeModal.onDidDismiss().then((data: any) => {
      if (data) this.expenditureType = data;
    });
    _expTypeModal.present();
  }

  async changeOutlet() {
    let _outletModal = await this.modalCtrl.create({
      component: OutletListPage,
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      mode: 'ios',
      componentProps: {
        clubOutletList: this.clubOutletList,
        fromClub: this.fromClub,
      },
    });
    _outletModal.onDidDismiss().then((data: any) => {
      if (data) this.selectedClubOutlet = data.data;
    });
    await _outletModal.present().then(() => {
      const height = this.platform.height() - 105;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  displayExpenditureType() {
    if (!this.expenditureType || this.expenditureType.length === 0) return 'Tap here to select';
    else return this.expenditureType;
  }

  displayOutlet() {
    if (!this.selectedClubOutlet || this.selectedClubOutlet.name.length === 0)
      return 'Tap here to select';
    else return this.selectedClubOutlet.name;
  }

  onTopupDateChange = (value: string) => {
    this.topupDate = value;
  };

  onExpiryDateChange = (value: string) => {
    this.expiryDate = value;
  };

  onTrxnDateChange = (value: string) => {
    this.trxnDate = value;
  };
}
